import { Component, OnInit } from '@angular/core';
import { SubscriptionService } from './subscription.service';
import { Observable } from 'rxjs';
import { Plan } from '@app/shared/models/db/plan.model';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-subscription',
  templateUrl: './subscription.component.html',
  styleUrls: ['./subscription.component.scss']
})
export class SubscriptionComponent implements OnInit {
  subscription$: Observable<Plan[]>;
  loading$: Observable<boolean>;
  selectedPlan: Plan;
  step: number = 1;

  constructor(
    private router: ActivatedRoute,
    private subscriptionService: SubscriptionService,
    private http: HttpClient
  ) {
    this.subscription$ = this.subscriptionService.subscription$;
    this.loading$ = this.subscriptionService.loading$;
  }

  ngOnInit(): void {
    this.subscriptionService.loadSubscription();
    this.router.queryParams.subscribe(param => {
      if (param.request && param.request === 'success') {
        this.step = 3;
      }
    });
  }

  selectPaymentMethod(type: string) {
    if (type === 'patreon') {
      this.step = 4;
    } else if (type === 'other') {
      this.step = 2;
    }
  }
}
